export const CITY_H1_PERSIANAS: Record<string, string> = {
  'malaga': 'Persianas en Málaga capital · reparación, motor y cinta en 24h',
  'marbella': 'Persianas en Marbella · Puerto Banús, Nueva Andalucía y Sierra Blanca',
  'fuengirola': 'Persianas en Fuengirola · Los Boliches, Torreblanca y centro',
  'torremolinos': 'Persianas en Torremolinos · La Carihuela, Playamar y Montemar',
  'benalmadena': 'Persianas en Benalmádena · Costa, Pueblo y Arroyo de la Miel',
  'mijas': 'Persianas en Mijas · La Cala, Calahonda y Riviera del Sol',
  'estepona': 'Persianas en Estepona · centro histórico, puerto y urbanizaciones',
  'velez-malaga': 'Persianas en Vélez-Málaga · Torre del Mar y Almayate',
  'rincon-de-la-victoria': 'Persianas en Rincón de la Victoria y La Cala del Moral',
  'cartama': 'Persianas en Cártama · Estación, Pueblo y nuevas urbanizaciones',
  'alhaurin-de-la-torre': 'Persianas en Alhaurín de la Torre · centro y Pinos de Alhaurín',
  'antequera': 'Persianas en Antequera · centro histórico y polígono industrial',
  'coin': 'Persianas en Coín · centro, La Trocha y urbanizaciones',
  'nerja': 'Persianas en Nerja · Balcón de Europa, Burriana y Capistrano',
  'alora': 'Persianas en Álora · pueblo blanco, Bermejo y Caracuel',
  'ronda': 'Persianas en Ronda · Tajo, Mercadillo y Ciudad',
  'alhaurin-el-grande': 'Persianas en Alhaurín el Grande · centro y La Capellanía',
};

export const CITY_H1_TOLDOS: Record<string, string> = {
  'malaga': 'Toldos en Málaga capital · motorizados, extensibles y cofre en 24h',
  'marbella': 'Toldos en Marbella · Puerto Banús, Nueva Andalucía y Sierra Blanca',
  'fuengirola': 'Toldos en Fuengirola · Los Boliches, Torreblanca y centro',
  'torremolinos': 'Toldos en Torremolinos · La Carihuela, Playamar y Montemar',
  'benalmadena': 'Toldos en Benalmádena · Costa, Pueblo y Arroyo de la Miel',
  'mijas': 'Toldos en Mijas · La Cala, Calahonda y Riviera del Sol',
  'estepona': 'Toldos en Estepona · centro histórico, puerto y urbanizaciones',
  'velez-malaga': 'Toldos en Vélez-Málaga · Torre del Mar y Almayate',
  'rincon-de-la-victoria': 'Toldos en Rincón de la Victoria y La Cala del Moral',
  'cartama': 'Toldos en Cártama · Estación, Pueblo y nuevas urbanizaciones',
  'alhaurin-de-la-torre': 'Toldos en Alhaurín de la Torre · centro y Pinos de Alhaurín',
  'antequera': 'Toldos en Antequera · centro histórico y polígono industrial',
  'coin': 'Toldos en Coín · centro, La Trocha y urbanizaciones',
  'nerja': 'Toldos en Nerja · Balcón de Europa, Burriana y Capistrano',
  'alora': 'Toldos en Álora · pueblo blanco, Bermejo y Caracuel',
  'ronda': 'Toldos en Ronda · Tajo, Mercadillo y Ciudad',
  'alhaurin-el-grande': 'Toldos en Alhaurín el Grande · centro y La Capellanía',
};

export const CITY_H1_MOSQUITERAS: Record<string, string> = {
  'malaga': 'Mosquiteras en Málaga capital · fijas, enrollables y correderas desde 60€',
  'marbella': 'Mosquiteras en Marbella · Puerto Banús, Nueva Andalucía y Sierra Blanca',
  'fuengirola': 'Mosquiteras en Fuengirola · Los Boliches, Torreblanca y centro',
  'torremolinos': 'Mosquiteras en Torremolinos · La Carihuela, Playamar y Montemar',
  'benalmadena': 'Mosquiteras en Benalmádena · Costa, Pueblo y Arroyo de la Miel',
  'mijas': 'Mosquiteras en Mijas · La Cala, Calahonda y Riviera del Sol',
  'estepona': 'Mosquiteras en Estepona · centro histórico, puerto y urbanizaciones',
  'velez-malaga': 'Mosquiteras en Vélez-Málaga · Torre del Mar y Almayate',
  'rincon-de-la-victoria': 'Mosquiteras en Rincón de la Victoria y La Cala del Moral',
  'cartama': 'Mosquiteras en Cártama · Estación, Pueblo y nuevas urbanizaciones',
  'alhaurin-de-la-torre': 'Mosquiteras en Alhaurín de la Torre · centro y Pinos de Alhaurín',
  'antequera': 'Mosquiteras en Antequera · centro histórico y polígono industrial',
  'coin': 'Mosquiteras en Coín · centro, La Trocha y urbanizaciones',
  'nerja': 'Mosquiteras en Nerja · Balcón de Europa, Burriana y Capistrano',
  'alora': 'Mosquiteras en Álora · pueblo blanco, Bermejo y Caracuel',
  'ronda': 'Mosquiteras en Ronda · Tajo, Mercadillo y Ciudad',
  'alhaurin-el-grande': 'Mosquiteras en Alhaurín el Grande · centro y La Capellanía',
};

export function getCityH1Persianas(slug: string, fallbackName: string): string {
  return CITY_H1_PERSIANAS[slug] || `Persianas en ${fallbackName} · reparación e instalación 24h`;
}

export function getCityH1Toldos(slug: string, fallbackName: string): string {
  return CITY_H1_TOLDOS[slug] || `Toldos en ${fallbackName} · instalación y reparación 24h`;
}

export function getCityH1Mosquiteras(slug: string, fallbackName: string): string {
  return CITY_H1_MOSQUITERAS[slug] || `Mosquiteras en ${fallbackName} · instalación desde 60€`;
}